import { Button } from "antd";
import React, { useEffect } from "react";
import { FiCheckCircle } from "react-icons/fi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifySession } from "../../api/pricing";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // Access query parameters
  const { session_id, planId } = Object.fromEntries(searchParams);

  useEffect(() => {
    if (planId && session_id) {
      async function getSessionData() {
        try {
          await verifySession(session_id, planId);
          // console.log(response);
          navigate("/payment-success", { replace: true });
        } catch (err) {
          console.log(err?.response?.data);
        }
      }
      getSessionData();
    }
  }, [navigate, planId, session_id]);

  return (
    <div className="subscription-success">
      <div className="container">
        <div className="d-flex justify-content-center">
          <div className="subscription-content text-center">
            <h1 className="title">Thank You!</h1>
            <p><FiCheckCircle className="success-icon" /></p>
            <p className="description">
              Your subscription payment has been successfully processed.
            </p>
            <Button size="large" className="text-decoration-none" type="primary" href="/billing">
              Go to Billing
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
